$('body').on('click', '.select-car', function() {
    var $this = $(this);
    if($this.hasClass('selected')) {
        return false;    
    }
    
    $this.addClass('selected');
    $this.attr('data-qty', 1);
    $this.find('input').val(1);
    $this.find('.price').html($this.attr('data-price'));
    
    return false;
});

$('body').on('click', '.select-car .update-qty', function() {
    var $this = $(this);
    var car = $this.parents('.select-car');
    var qty = parseInt(car.attr('data-qty'));
    var price = parseInt(car.attr('data-price'));

    switch ($this.attr('data-mode')) {
        case 'add':
            qty++;
            car.attr('data-qty', qty);
            car.find('input').val(qty);
            car.find('.price').html(price*qty);
            break;
        case 'minus':
            qty--;
            car.attr('data-qty', qty);
            car.find('input').val(qty);
            car.find('.price').html(price * qty);

            if(qty === 0) {
                car.removeClass('selected');
            }
            break;
    }
    
    return false;
});

$('body').on('focus', '.select-car .select-qty input', function() {
    var $this = $(this);
    $this.select();
    return false;
});

$('body').on('blur', '.select-car .select-qty input', function() {
    var $this = $(this);
    var car = $this.parents('.select-car');
    var qty = parseInt(car.attr('data-qty'));
    var price = parseInt(car.attr('data-price'));

    qty = isNaN($this.val()) ? qty : parseInt($this.val());
    car.attr('data-qty', qty);
    car.find('input').val(qty);
    car.find('.price').html(price * qty);

    if (qty === 0) {
        car.removeClass('selected');
    }
});

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function changeStep(step) {
    $('.step').removeClass('active');
    $('.step[data-step="'+step+'"]').addClass('active');
}

function parseWeek(data, weekIndex, mode) {
    var times = ``;
    var dates = ``;

    // loop through the dates
    $.each(data, function (index, date) {
        times = ``;

        $.each(date.times, function(index, time) {
            times += `<li>
                <a href="" class="select-time" data-time="${time.raw}" data-zone="${date.zone}" data-driver="${date.driver}" data-location="${date.location}" data-mode="${mode}">${time.parsed}</a>
            </li>`;
        });

        dates += `<div class="date">
            <header>${date.date.day} <span>${date.date.date}</span></header>
            <div class="times">
                <ul>
                    ${times}
                </ul>
            </div>
        </div>`;
    });

    // return the week
    return `<div class="week ${weekIndex === 0 ? 'active' : ''}">
        ${dates}
    </div>`;
}

function updateNavigation() {
    var step = $('.step[data-step="appointment"]');

    $('.navigation a', step).removeClass('hidden');
    
    // if no weeks hide the navigation
    if(!$('.weeks .week', step).length) {
        $('.navigation a', step).addClass('hidden');
        return false;
    }

    if (!$('.weeks .week.active', step).next().length) {
        $('.navigation a[data-direction="next"]', step).addClass('hidden');
    }

    if (!$('.weeks .week.active', step).prev().length) {
        $('.navigation a[data-direction="previous"]', step).addClass('hidden');
    }
}

$('body').on('click', '.step[data-step="error"] .restart', function() {
    changeStep('search');

    // clear the cars
    $('.select-car').each(function(){
        var $this = $(this);

        $this.removeClass('selected');
        $this.attr('data-qty', 0);
        $this.find('input').val(0);
        $this.find('.price').html(0);
    });

    // clear the times
    $('.step[data-step="appointment"] .select-time');
    var step = $('.step[data-step="appointment"]');
    $('.select-time', step).removeClass('selected');
    $('[name="zone"]', step).val('');
    $('[name="driver"]', step).val('');
    $('[name="location"]', step).val('');
    $('[name="time"]', step).val('');
    $('[name="mode"]', step).val('');

    return false;
});

$('body').on('click', '.step[data-step="appointment"] .navigate-schedule', function() {
    var $this = $(this);
    var step = $('.step[data-step="appointment"]');
    var activeWeek = $('.weeks .week.active', step);

    switch ($this.attr('data-direction')) {
        case 'next':
            activeWeek.next().addClass('active');
            activeWeek.removeClass('active');
            break;
        case 'previous':
            activeWeek.prev().addClass('active');
            activeWeek.removeClass('active');
            break;
    }

    updateNavigation();
    return false;
});

$('body').on('submit', '.step[data-step="search"] form', function() {
    var $this = $(this);

    if (!$('.select-car.selected').length) {
        showNotice('Error', 'Please choose a car', 'close');
        return false;
    }

    var error = false;
    var emailError = false;
    $('.required', $this).each(function () {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('Error', 'Please fill out all required fields', 'close');
        return false;
    }

    if (emailError) {
        showNotice('Error', 'Please enter a valid email address', 'close');
        return false;
    }
    
    var payload = {};
    var cars = [];

    $('.select-car.selected').each(function() {
        var $this = $(this);
        cars.push({
            'car': $this.attr('data-car'),
            'qty': $this.attr('data-qty')
        });
    });

    payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    payload.cars = cars;
    payload.street = $('[name="street"]', $this).val();
    payload.city = $('[name="city"]', $this).val();
    payload.state = $('[name="state"]', $this).val();
    payload.zip = $('[name="zip"]', $this).val();

    changeStep('loading');

    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            console.log(data);

            if(data.appointment) {
                // change the form action
                var step = $('.step[data-step="appointment"]');
                var action = $('form', step).attr('data-action').replace('{appointment}', data.appointment);
                $('form', step).attr('action', action);
            }

            if (!data.success) {
                changeStep('error');
                $('.step[data-step="error"] .message').html(data.message);

                // setup the williamsburg
                if(data.williamsburg) {
                    // setup the williamsburg modal

                    $('.williamsburg .notice-message').html(data.williamsburg.modal);
                    if(data.williamsburg.location) {
                        $('.williamsburg .button.load-weeks').show().html(data.williamsburg.location).attr('data-weeks', JSON.stringify(data.williamsburg.weeks));
                    } else {
                        $('.williamsburg .button.load-weeks').hide();
                    }

                    if(data.williamsburg.home) {
                        $('.williamsburg .button.close').show().html(data.williamsburg.home);
                    } else {
                        $('.williamsburg .button.close').hide();
                    }

                    setTimeout(() => {
                        openModal('.williamsburg');
                    }, data.williamsburg.inteval);
                }


                return false;
            }

            

            // reset the weeks, add the data
            $('.weeks', step).html('');
            $.each(data.weeks, function(index, week) {
                $('.weeks', step).append(parseWeek(week, index, 'home'));
            });

            // change the step
            changeStep('appointment');
            // update the navigation
            updateNavigation();

            // setup the williamsburg
            if(data.williamsburg) {
                // setup the williamsburg modal

                $('.williamsburg .notice-message').html(data.williamsburg.modal);
                if(data.williamsburg.location) {
                    $('.williamsburg .button.load-weeks').show().html(data.williamsburg.location).attr('data-weeks', JSON.stringify(data.williamsburg.weeks));
                } else {
                    $('.williamsburg .button.load-weeks').hide();
                }

                if(data.williamsburg.home) {
                    $('.williamsburg .button.close').show().html(data.williamsburg.home);
                } else {
                    $('.williamsburg .button.close').hide();
                }

                setTimeout(() => {
                    openModal('.williamsburg');
                }, data.williamsburg.inteval);
            }
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });


    return false;
});

$('body').on('click', '.load-weeks', function() {
    var $this = $(this);
    var weeks = JSON.parse($this.attr('data-weeks'));
    var step = $('.step[data-step="appointment"]');

    $('.weeks', step).html('');
    $.each(weeks, function(index, week) {
        $('.weeks', step).append(parseWeek(week, index, $this.attr('data-mode')));
    });

    closeModal();
    return false;
});

$('body').on('click', '.step[data-step="appointment"] .select-time', function() {
    var $this = $(this);
    var step = $('.step[data-step="appointment"]');

    $('.select-time', step).removeClass('selected');
    $this.addClass('selected');

    $('[name="zone"]', step).val($this.attr('data-zone'));
    $('[name="driver"]', step).val($this.attr('data-driver'));
    $('[name="location"]', step).val($this.attr('data-location'));
    $('[name="time"]', step).val($this.attr('data-time'));
    $('[name="mode"]', step).val($this.attr('data-mode'));
    
    return false;
});

$('body').on('submit', '.step[data-step="appointment"] form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };

    var error = false;
    var emailError = false;
    $('.required', $this).each(function() {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('Error', 'Please fill out all required fields', 'close');
        return false;
    }

    if (emailError) {
        showNotice('Error', 'Please enter a valid email address', 'close');
        return false;
    }

    changeStep('loading');

    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: fields,
        dataType: 'json',
        success: function(data) {
            console.log(data);

            if (!data.success) {
                changeStep('error');
                $('.step[data-step="error"] .message').html(data.message);
                return false;
            }

            changeStep('success');
            $('.step[data-step="success"] .message').html(data.message);

        },
        error: function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});